import React, { FC } from 'react'
import { ThemeProvider } from '@material-ui/styles'
import { useSelector } from 'react-redux'

// import Header from 'layout/header'
import themes from 'theme'
// import useSiteMetadata from 'hooks/useSiteMetadata'
import { RootState } from 'redux/store'

const LayoutComponent: FC = ({ children }) => {
  // const { title } = useSiteMetadata()
  return (
    <div className="default">
      {/* <Header siteTitle={title} /> */}
      <main>{children}</main>
    </div>
  )
}

const Layout: FC = ({ children }) => {
  const { theme } = useSelector((state: RootState) => state.app)

  return (
    <ThemeProvider theme={themes[theme]}>
      <LayoutComponent>{children}</LayoutComponent>
    </ThemeProvider>
  )
}

export default Layout
